import { useCallback } from 'react';

import { useNavigate, useLocation } from 'react-router-dom';

import { useUnifiedBusinessEntityContext } from '#client/contexts/UnifiedBusinessEntityProvider';

import { useNavigationContext } from './useNavigationContext';
import {
  validateBusinessEntityState,
  determineNavigationStrategy
} from '../utils/navigationValidation';

export const useCloseNavigation = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { businessEntityUuid, loading, error } = useUnifiedBusinessEntityContext();
  const { getContext, clearContext } = useNavigationContext();

  const handleCloseChat = useCallback(() => {
    // Get navigation context first (includes referrer, history, etc.)
    const context = getContext();

    // Clear context immediately so it doesn't persist for next visit
    // This prevents stale referrer data from causing incorrect navigation
    clearContext();

    // Get appropriate fallback route based on user mode
    const { route: fallbackRoute } = validateBusinessEntityState({
      businessEntityUuid,
      loading,
      error
    });

    // Try context-based navigation strategy (referrer, back, etc.)
    const { type, target } = determineNavigationStrategy(context, { pathname }, fallbackRoute);

    // Handle navigation based on strategy type
    if (type === 'back') {
      return navigate(-1);
    }

    if (type === 'dashboard' || type === 'referrer' || pathname !== target) {
      window.location.replace(target);
      return;
    }

    // Final fallback
    window.location.replace(fallbackRoute || '/velo');
  }, [navigate, pathname, businessEntityUuid, loading, error, getContext, clearContext]);

  return { handleCloseChat };
};
